"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchModerationNotes = exports.getModerationNoteQuery = void 0;
var apiService_1 = __importDefault(require("@common/services/apiService"));
function getModerationNoteQuery(ad) {
    return {
        documentId: ad.id,
        remoteId: ad.remoteId.id,
        userId: ad.current.user.id || '',
        ipAddress: ad.current.user.ipAddress || '',
        'userEmails[]': ad.current.user.emailAddresses || [],
        'userPhoneNumbers[]': ad.current.user.phoneNumbers || [],
    };
}
exports.getModerationNoteQuery = getModerationNoteQuery;
var getIntersectionArray = function (a, b) {
    var setA = new Set(a);
    return b.filter(function (value) { return setA.has(value); });
};
function fetchModerationNotes(domain, ad) {
    return apiService_1.default.getModerationNotes(__assign(__assign({}, getModerationNoteQuery(ad)), { domain: domain })).then(function (resp) {
        return resp.data.notes.map(function (note) {
            var noteWithMatching = __assign({}, note);
            noteWithMatching.matchingFields = {
                id: note.remoteId === ad.remoteId.id,
                user: note.userId === ad.current.user.id,
                ip: note.ipAddress === ad.current.user.ipAddress,
                email: getIntersectionArray(note.userEmails, ad.current.user.emailAddresses || []).length > 0,
                phone: getIntersectionArray(note.userPhoneNumbers, ad.current.user.phoneNumbers || []).length > 0,
            };
            return noteWithMatching;
        });
    });
}
exports.fetchModerationNotes = fetchModerationNotes;
